import {connect} from 'react-redux';

import {KnowledgeBaseComposerDropdown} from '../../../../../libs/knowledge-base/shared/components/composerIntegration/knowledgeBaseComposerDropdown';
import {
  getFlatKnowledgeBases,
  getFlatPublishedExternalKnowledgeBases,
} from '../../../../../libs/shared/core/src/store/data/knowledgeBases/knowledgeBasesSelectors';
import {NewPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getCompanyUrl} from '../../../../store/data/company/companySelectors';
import {
  updatePreferredKnowledgeBaseIdAction,
  updatePreferredKnowledgeBaseLocaleAction,
} from '../../../../store/data/localPreferences/localPreferencesActions';
import {
  getPreferredKnowledgeBaseId,
  getPreferredKnowledgeBaseLocale,
} from '../../../../store/data/localPreferences/localPreferencesSelectors';

/*
 * Props.
 */

interface KnowledgeBaseDropdownContainerProps {
  panelId: NewPanelId;
}

/*
 * Selectors.
 */

const getFallbackLocale = createSelector(
  [getFlatKnowledgeBases, getPreferredKnowledgeBaseId],
  (knowledgeBases, prefKnowledgeBaseId) => {
    const knowledgeBase = knowledgeBases.find((kb) => kb.id === prefKnowledgeBaseId) || knowledgeBases[0];
    if (!knowledgeBase) {
      return undefined;
    }
    return knowledgeBase.defaultLocale;
  },
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<KnowledgeBaseDropdownContainerProps>()(() => ({
  companyUrl: getCompanyUrl,
  preferredKnowledgeBaseId: getPreferredKnowledgeBaseId,
  preferredKnowledgeBaseLocale: getPreferredKnowledgeBaseLocale,
  fallbackLocale: getFallbackLocale,
  knowledgeBases: getFlatPublishedExternalKnowledgeBases,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updatePreferredKnowledgeBaseId: updatePreferredKnowledgeBaseIdAction,
  updatePreferredKnowledgeBaseLocale: updatePreferredKnowledgeBaseLocaleAction,
}));

export const KnowledgeBaseComposerDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(KnowledgeBaseComposerDropdown);
